import { PageRoutes } from "../constants/historyGaming";

const isActiveHomePage = (path: string) => {
  return path === PageRoutes.HomePage;
};

const isActiveRankPage = (path: string) => {
  return path === PageRoutes.Friends;
};

const isActiveFriendPage = (path: string) => {
  return path === PageRoutes.Friends;
};

const isActiveShopPage = () => {
  const pathname = window.location.pathname;
  return pathname === PageRoutes.Shop;
};

const isShowMainHeader = () => {
  const pathname = window.location.pathname;
  return (
    isActiveRankPage(pathname) ||
    isActiveFriendPage(pathname) ||
    isActiveShopPage() ||
    isActiveHomePage(pathname)
  );
};

const getCurrentLocation = () => {
  const pathname = window.location.pathname;
  if (pathname.includes(PageRoutes.Profile)) return "profile";
  if (pathname.includes(PageRoutes.BundleDetail)) return "bundleDetail";

  switch (pathname) {
    case PageRoutes.HomePage:
      return "home";
    case PageRoutes.Friends:
      return "friends";
    case PageRoutes.Shop:
      return "shop";
    case PageRoutes.Rank:
      return "rank";
    case PageRoutes.Profile:
      return "profile";
    default:
      return "home";
  }
};

export const GamingLocation = {
  getCurrentLocation,
  isShowMainHeader,
  isActiveShopPage,
  isActiveHomePage,
};
